import React from 'react';
import {
  DocumentContainer,
  DocumentContent,
  DocumentFooter,
  DocumentHeader,
  DocumentHeaderLeft,
  DocumentHeaderRight,
  Title,
  Value
} from './RuleItem.styled';
import MenuButtonWrapper from '../../../../../elements/v2/MenuButtonWrapper';

const RuleItem = ({ name, description, period, trigger, contacts, channels }) => {
  const handleContainerClick = (e) => {
    if (e.target.closest('.menu-wrapper')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  };

  const menuItems = [
    { 
      label: 'Edit Rule', 
      onClick: () => console.log('Edit clicked')
    },
    { 
      label: 'Duplicate', 
      onClick: () => console.log('Duplicate clicked')
    },
    { 
      label: 'Archive Rule', 
      onClick: () => console.log('Archive clicked')
    }
  ];

  return (
    <DocumentContainer 
      onClick={handleContainerClick}
      style={{ cursor: 'pointer' }}
      data-testid="rule-container"
    >
      <DocumentHeader>
        <DocumentHeaderLeft>{name}</DocumentHeaderLeft>
        <DocumentHeaderRight>
          <div 
            className="menu-wrapper"
            onClick={(e) => {
              e?.preventDefault();
              e?.stopPropagation();
            }}
          >
            <MenuButtonWrapper items={menuItems} />
          </div>
        </DocumentHeaderRight>
      </DocumentHeader>
      <DocumentContent>{description}</DocumentContent>
      <DocumentFooter>
        <div>
          <Title>Period: </Title>
          <Value>{period}</Value>
        </div>
        <div>
          <Title>Trigger: </Title>
          <Value>{trigger}</Value>
        </div>
        <div>
          <Title>Contacts: </Title>
          <Value>{contacts}</Value>
        </div>
        <div>
          <Title>Channels: </Title>
          <Value data-testid="channels-value">{channels?.length ? channels.join(', ') : '-'}</Value>
        </div>
      </DocumentFooter>
    </DocumentContainer>
  );
};

export default RuleItem; 